'use client';

import Link from 'next/link';

export default function DatenschutzPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0f1e', color: '#e2e8f0', fontFamily: "'Inter', sans-serif" }}>
      {/* Header */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontWeight: 800, fontSize: 22, color: '#fff' }}>
              Done<span style={{ color: '#F26522' }}>2</span>Go
            </span>
          </Link>
          <Link href="/" style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px 80px' }}>
        <h1 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 36, fontWeight: 800, color: '#fff', marginBottom: 8 }}>Datenschutzerklärung</h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', marginBottom: 48 }}>Stand: Juni 2026 · gemäß DSGVO</p>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>1. Verantwortlicher</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Verantwortlicher im Sinne der DSGVO ist:<br /><br />
            Done2Go<br />
            [Straße und Hausnummer]<br />
            [PLZ Ort], Deutschland<br />
            E-Mail: <a href="mailto:info@done2go.com" style={{ color: '#F26522', textDecoration: 'none' }}>info@done2go.com</a>
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>2. Erhebung und Speicherung personenbezogener Daten</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Beim Besuch unserer Website werden automatisch Informationen allgemeiner Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem, den Domainnamen Ihres Internet-Service-Providers und ähnliches. Hierbei handelt es sich ausschließlich um Informationen, welche keine Rückschlüsse auf Ihre Person zulassen.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>3. Kontaktformular</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.<br /><br />
            Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>4. Cookies</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Unsere Website verwendet Cookies. Dabei handelt es sich um kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.<br /><br />
            Einige Cookies sind „Session-Cookies". Solche Cookies werden nach Ende Ihrer Browser-Sitzung von selbst gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Solche Cookies helfen uns, Sie bei Rückkehr auf unserer Website wiederzuerkennen.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>5. Ihre Rechte</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </p>
          <ul style={{ lineHeight: 2, color: 'rgba(255,255,255,0.75)', paddingLeft: 24, marginTop: 12 }}>
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
          </ul>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)', marginTop: 16 }}>
            Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>6. Datensicherheit</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256-Bit-Verschlüsselung. Falls Ihr Browser keine 256-Bit-Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit-v3-Technologie zurück.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>7. Aktualität und Änderung dieser Datenschutzerklärung</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Juni 2026. Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
          </p>
        </section>

        {/* Footer links */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 32, marginTop: 48, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          <Link href="/impressum" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Impressum</Link>
          <Link href="/datenschutz" style={{ fontSize: 13, color: '#F26522', textDecoration: 'none' }}>Datenschutz</Link>
          <Link href="/agb" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>AGB</Link>
        </div>
      </div>
    </div>
  );
}
